<template>
  <div class="GlobalFormDemo">
    <GlobalForm class="search-form" :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :needBtnLoading="true"
      :inline="true" round :labelWidth="90" @handleConfirm="handleConfirm" confirmBtnName="查询">
      <el-form-item class="el_from" label="商品编号" slot="productCode" style="margin: 0" label-width="75px">
        <el-input v-model="productCode" :clearable="true" size="mini" placeholder="请输入商品编号"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="库存位置" slot="stockStoreId" style="margin: 0" label-width="75px">
        <el-select v-model="stockStoreId" placeholder="请输入或选择库存位置" filterable clearable>
          <el-option v-for="item in storeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="商品类型" slot="catalog" style="margin: 0" label-width="75px">
        <el-select v-model="catalog" size="mini" placeholder="请选择" clearable>
          <el-option v-for="item in catalogData" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="是否可调店" slot="diaodian" style="margin: 0" label-width="85px">
        <el-select v-model="isTransferStore" size="mini" placeholder="请选择" clearable>
          <el-option v-for="item in diaoData" :key="item.label" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="el_from" label="机型名称" slot="machineName" style="margin: 0" label-width="75px">
        <el-input v-model="machineName" :clearable="true" size="mini" placeholder="请输入机型名称"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="商品标题" slot="productName" style="margin: 0" label-width="75px">
        <el-input v-model="productName" :clearable="true" size="mini" placeholder="请输入商品标题"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="串号" slot="imei" style="margin: 0" label-width="40px">
        <el-input v-model="imei" :clearable="true" size="mini" placeholder="请输入串号"></el-input>
      </el-form-item>
      <el-form-item class="el_from" label="最近上架时间" slot="xiaSelect" style="margin: 0" label-width="100px">
        <el-date-picker v-model="entryTime" type="daterange" start-placeholder="开始日期" range-separator="~"
          end-placeholder="结束日期" clearable :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item class="el_from" label="创建时间" slot="shenationSelect" style="margin: 0" label-width="75px">
        <el-date-picker v-model="shtryTime" type="daterange" start-placeholder="开始日期" range-separator="~"
          end-placeholder="结束日期" clearable :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
    </GlobalForm>
    <div style="text-align: right;margin-bottom: 20px" slot="AddSlot">
      <el-button type="warning" size="mini" @click.native="storegoodsDialog = true;getCompanyCustomConfig()">小程序商品管理权限</el-button>
      <el-button icon="el-icon-download" size="small" :loading="exportLoading" type="success" @click="exportExcel">导出Excel</el-button>
    </div>
    <el-dialog title="导入销售记录" :visible.sync="importVisible" :close-on-click-modal="false" class="import-business-dialog"
      width="500px">
      <div class="cance-tip">
        <div>
          说明：请下载数据模板后按照表格提示填写后导入
        </div>
      </div>
      <div class="step">
        <div class="step-title">
          <span>Step1</span>
        </div>
        <div class="step-content">
          <span style="margin-right: 12px">表格下载</span>
          <el-link type="primary" @click="download">点击下载模板表格</el-link>
        </div>
        <div class="step-title">
          <span>Step2</span>
        </div>
        <div class="tip">
          <span class="tip-title">上传表格</span>
          <span class="tip-content">请上传.xls或.xlsx格式的excel文件，大小10M内</span>
        </div>
        <div class="step2-content">
          <el-upload ref="upload" :limit="1" :headers="headers" :auto-upload="false" :http-request="uploadFile"
            :before-upload="onUpload" accept=".xls,.xlsx" action="customize">
            <el-button slot="trigger" size="small" type="primary">选取文件
            </el-button>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="importVisible = false">取消</el-button>
        <el-button type="primary" @click.native="importSuccess">确定</el-button>
      </span>
    </el-dialog>
    <!-- <GlobalDialog title="操作提示" :show="codeShow" @submitPopupData="codeSubmit" :width="500" top="6%"
      @onClose="codeShow = false; code = ''" @resetPopupData=" codeShow = false; code = ''">
      <p style="font-size: 16px;text-align: center;color: #000;margin-bottom: 20px;">{{
        isLeadingOut ? '是否确认导出订单？' : '是否确定导入代卖销售数据？' }}</p>
      <el-form>
        <el-form-item label="动态口令" label-width="80px">
          <el-input placeholder="请输入谷歌动态口令" v-model="code" clearable />
        </el-form-item>
      </el-form>
    </GlobalDialog> -->
    <GlobalDialog title="操作提示" :show="cdShow" @submitPopupData="cdSubmit" :width="500" top="6%"
      @onClose=" codeShow = false; command = ''" @resetPopupData=" cdShow = false; command = ''">
      <p style="font-size: 16px;text-align: center;color: #000;margin-bottom: 20px;">
        是否确定导入代卖销售数据?</p>
      <el-form>
        <el-form-item label="动态口令" label-width="80px">
          <el-input placeholder="请输入谷歌动态口令" v-model="command" clearable />
        </el-form-item>
      </el-form>
    </GlobalDialog>
    <!-- 确认导表订单 -->
    <el-dialog title="确认导入订单" :visible.sync="sureExDialog" :close-on-click-modal="false" width="800px">
      <div class="exStitle">说明：请确认导入订单，导入后系统自动根据销售价计算代卖商户结算金额</div>
      <GlobalTable ref="GlobalTable" :columns="urtableColumns" :data="urDataList" :maxHeight="700" :isPagination="false">
        <el-table-column label="订单状态" slot="storeName" align="center">
          <template>
            <span>已取消</span>
          </template>
        </el-table-column>
        <el-table-column label="销售价" slot="smStaffName" align="center">
          <template slot-scope="{ row }">
            <span style="color: red;" v-if="row.sellPrice">{{ row.sellPrice }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="销售渠道" slot="waitAmount" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.sellTypeAct === "1" ? 'C端' : 'B端' }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click=" sureExDialog = false">关 闭</el-button>
        <el-button size="small" type="primary" @click.native="exportSure">确定</el-button>
      </span>
    </el-dialog>
    <!-- 商品入库权限 -->
    <el-dialog title="商品入库权限" :visible.sync="storegoodsDialog"   @close="perClose" :close-on-click-modal="false" width="400px">
      <el-form ref="form" :model="storeform" label-width="80px">
        <el-form-item label="是否开启店长入库：" label-width="140px">
          <el-radio-group v-model="storeform.isSmInStock">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否允许店长上/下架：" label-width="158px">
          <el-radio-group v-model="storeform.isSmPutaway">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="storegoodsDialog = false">关 闭</el-button>
        <el-button size="small" type="primary" @click.native="permissionSure">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import { MessageBox } from "element-ui";
import { encryptByDES } from "@/utils/3DES";
import { conmentExcel, moveImport, importSave } from "../../../utils/request/newIndex";
import GlobalDialog from "@/components/global/components/GlobalDialog.vue";
export default {
  name: "Form",
  components: { GlobalDialog },
  props: {},
  data() {
    return {
      storeform: {
        isSmInStock: '',
        isSmPutaway:""
      },
      storegoodsDialog: false,
      storeList: [],
      command: "",
      cdShow: false,
      sureExDialog: false,
      urtableColumns: [
        { label: "代卖码", prop: "phoneUid" },
        { label: "代卖商户", prop: "businessName" },
        { slotName: "storeName" },
        { slotName: "smStaffName" },
        { slotName: "waitAmount" },
      ],
      urDataList: [],
      SestateData: [
        {
          label: "线上销售",
          value: '00'
        },
        {
          label: "线下销售",
          value: '01'
        }
      ],
      // 是否导出还是导入
      isLeadingOut: false,
      codeShow: false,
      headers: {
        ACCESS_TOKEN: localStorage.getItem("token"),
        channel: "platformPc",
        TOKEN: "",
      },
      // 弹框
      importVisible: false,
      code: "",
      machineName: "",
      productName: "",
      recycleOrderNo: "",
      phoneUid: "",
      chxOrderNo: "",
      buyBusinessList: [],
      merchantSelectList: [],
      businessIdSelectList: [{
        id: "01",
        name: "回收商",
      }, {
        id: "02",
        name: "门店商",
      }],
      stateSelectList: [{
        id: "60",
        name: "验货中",
      }, {
        id: "65",
        name: "待报价",
      }, {
        id: "70",
        name: "报价完成",
      }, {
        id: "80",
        name: "已完成",
      }, {
        id: "90",
        name: "已取消",
      }],
      filtterSelectList: [],
      catalog: "",
      catalogData: [
        {
          label: "优品机",
          value: '00'
        },
        {
          label: "演示机",
          value: '01'
        },
        {
          label: "资源机",
          value: '02'
        }
      ],
      isTransferStore:"",
      diaoData: [
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        },
      ],
      initData: null,
      dialogVisible: false,
      productCode: "",
      companyId: "",
      stockStoreId: "",
      entryTime: null,
      shtryTime: null,
      imei: "",
      companySelectList: [],
      companyMatchSelectList: [],
      allMerchantSelectList: [],
      formItemList: [{ slotName: "machineName" }, { slotName: "imei" }, { slotName: "productName" }, { slotName: "productCode" }, { slotName: "stockStoreId" }, { slotName: "catalog" },{slotName:'diaodian'} ,{ slotName: "xiaSelect" }, { slotName: "shenationSelect" }],
      modelform: {
        matchChannelId: "",
        merchantId: "",
        companyId: "",
        takeEffectTime: "",
        command: "",
      },
      SeachParams: {},
      formRules: {},
      butLoading: false,
      middleRegionVos: [],
      dialogMiddleRegionTitle: "",
      dialogMiddleRegionVisible: false,
      dialogDelVisible: false,
      commandDisableShow: false,
      applyEndTime: "",
      applyStartTime: '',
      createEndTime: "",
      createStartTime: "",
      exportLoading: false
    };
  },
  created() {
    this.productCode = this.$route.query.productCode
    this.handleConfirm();
    this.getAllStoreSelectList()
    // this.getCompanyCustomConfig()
  },
  methods: {
    //商品入库权限确定
    permissionSure() {
      console.log(this.storeform);
      _api.setSmInStock({
        "isSmInStock": this.storeform.isSmInStock,
        "isSmPutaway": this.storeform.isSmPutaway
      }).then(res => {
        this.storegoodsDialog = false
        this.$message({
          message: '操作成功！',
          type: 'success'
        });
      })
    },
    perClose(){
      // this.getCompanyCustomConfig()
    },
    //获取商品入库权限
    getCompanyCustomConfig() {
      _api.getCompanyCustomConfig().then(res => {
        this.storeform.isSmInStock = res.data.isSmInStock
        this.storeform.isSmPutaway = res.data.productIsSmPutaway
      })
    },
    // 获取全部门店
    getAllStoreSelectList() {
      this.storeList = []
      _api.getAllStoreSelectList().then(res => {
        if (res.code == 1) {
          this.storeList = res.data
          this.storeList.unshift({
            isEnable: true,
            key: "-1",
            value: "公司总部",
          })
        }
      })
    },
    //确认导出
    cdSubmit() {
      importSave({ list: this.urDataList, command: this.command }).then(res => {
        if (res.code === 1) {
          this.$message({
            message: '导入成功！',
            type: 'success'
          });
          this.sureExDialog = false
          this.cdShow = false
          this.command = ""
          this.urDataList = []
          this.importVisible = false;
          this.handleConfirm()
          //清空上传文件
          this.$refs.upload.clearFiles();
        } else {
          //清空上传文件
          this.$refs.upload.clearFiles();
          this.$message.error(res.msg);
        }
      }).catch(err => {
        //清空上传文件
        this.$refs.upload.clearFiles();
        // this.$message.error(err.msg);
      })
    },
    exportSure() {
      this.cdShow = true
    },
    onUpload(e) {
      let TOKEN = encryptByDES(
        encryptByDES(
          new Date().getTime().toString(),
          "63e42c2444e94c1ebca21d30d2aa39a5"
        ),
        localStorage.getItem("token") || ""
      );
      this.headers.TOKEN = TOKEN;
    },
    //下载模板
    download() {
      const link = document.createElement("a");
      link.href = "/static/导入线下销售数据模板.xlsx";
      link.setAttribute("download", "线下销售数据模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
    // 上传文件
    uploadFile(params) {
      const _file = params.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      this.urDataList = []
      moveImport(formData).then((res) => {
        if (res.code === 1) {
          this.sureExDialog = true
          this.urDataList = res.data
        } else {
          //清空上传文件
          this.$refs.upload.clearFiles();
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      }).catch(err => {
        //清空上传文件
        this.$refs.upload.clearFiles();
        // this.$message.error(err.msg);
      });
    },
    importSuccess() {
      this.$refs.upload.submit();
      // this.importVisible = false;
    },
    handleConfirm(data,cd) {
      //最近上架时间
      if (this.entryTime === null) {
        this.createStartTime = "";
        this.createEndTime = "";
      } else {
        this.createStartTime = moment(this.entryTime[0]).format("x");
        this.createEndTime = moment(this.entryTime[1]).format("x");
      }
      //创建时间
      if (this.shtryTime === null) {
        this.applyStartTime = "";
        this.applyEndTime = "";
      } else {
        this.applyStartTime = moment(this.shtryTime[0]).format("x");
        this.applyEndTime = moment(this.shtryTime[1]).format("x");
      }
      console.log(this.entryTime, this.createStartTime, this.createEndTime);
      const SeachParams = {
        catalog: this.catalog,
        isTransferStore:this.isTransferStore,
        stockStoreId: this.stockStoreId,
        productCode: this.productCode,
        endTimeCreate: this.applyEndTime,
        startTimeCreate: this.applyStartTime,
        endTimePutawayLast: this.createEndTime,
        startTimePutawayLast: this.createStartTime,
        machineName: this.machineName,
        productName: this.productName,
        imei: this.imei,
        pageNum: 1,
        pageSize: 10,
      };
      this.SeachParams = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    exportExcel(e) {
      this.exportLoading = true
      _api.exportGoods({ ...this.SeachParams }).then((res) => {
        const content = res;
        const blob = new Blob([content]);

        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              MessageBox.alert(data.msg, "错误提示", {
                type: "error",
              });
            }
          } catch (err) {
            const fileName = "商品列表明细.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
        this.exportLoading = false
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.exStitle {
  margin-bottom: 15px;
  color: #ff8080;
  font-size: 14px;
}

.import-business-dialog {
  .step {
    .step-title {
      color: #0981ff;
      margin-bottom: 10px;
      padding-left: 6px;
      border-left: 3px solid;
      border-radius: 1.5px;
    }

    .step-content,
    .step2-content {
      margin-bottom: 26px;
    }

    .step2-content>div {
      display: flex;
    }

    .step2-content {
      .upload-demo {
        display: flex;
        justify-content: start;

        .el-upload-list {
          width: 200px;
        }
      }
    }

    .tip {
      margin-bottom: 12px;

      .tip-title {
        color: #666666;
        margin-right: 12px;
      }

      .tip-content {
        color: #ff687b;
        font-size: 12px;
      }
    }
  }
}

.cance-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;
}

.GlobalFormDemo {
  /deep/ .el-form--inline .el-form-item {
    margin-right: 10px !important;
  }

  .search-form {
    /deep/ .el-select>.el-input {
      width: 185px !important;
    }
  }

  .add-form {
    /deep/ .el-input-group__append {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }

    /deep/ .el-input-group__prepend {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }

    /deep/ .el-select {
      width: 100%;
    }
  }

  .rules-form {
    .rule-title {
      display: flex;
      align-items: center;
      color: #ff8080;
      margin-bottom: 20px;
    }

    .tip_ico {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }

    /deep/ .el-input-group__append {
      border: 1px solid #0981ff;
      background: #0981ff;
      color: #ffffff;
    }
  }

  .del-title {
    color: #ff8080;
    font-size: 12px;

    .sure_tip {
      margin-top: 15px;
      font-size: 16px;
      color: #333333;
    }
  }

  .command {
    display: flex;
    align-items: center;

    /deep/ .el-input {
      width: 300px;
    }
  }
}
</style>
